import type {
    ContentLink,
    ContentInlineVideoProps,
    ContentVideoSource,
    ThemeItem,
    ThemeType,
    ContentImage,
    ContentBlock,
    BlockType,
    ContentResourceLocation,
    BreakpointType,
} from './content';
import {
    ContentBlockThemeStyleItems
} from './content';
import type {
    RoundedValueCustom
} from '~/types';



export type ContentBlockButtonTypeLink = 'link' | 'external' | 'youtube' | 'video' | 'image';

export interface ContentBlockCustomIcon {
    icon?: ThemeItem<ContentResourceLocation>;
}

export interface ContentBlockTextTitle extends ContentBlockCustomIcon {
    content?: Nullable<string>;
}

export interface ContentBlockTextSubTitle extends ContentBlockCustomIcon {
    content?: Nullable<string>;
}

export interface ContentBlockTextCaption extends ContentBlockCustomIcon {
    content?: Nullable<string>;
}

export interface ContentBlockTextBody extends ContentBlockCustomIcon {
    content?: Nullable<string>;
}

export interface ContentBlockTextButtonItem extends ContentLink {
    type: ContentBlockButtonTypeLink;
    content: Nullable<string>;
    theme: ThemeItem<ContentBlockThemeStyleItems>;
}

export interface ContentBlockTextButton {
    items: ContentBlockTextButtonItem[];
}

// Text Block
export interface ContentBlockText {
    title: ContentBlockTextTitle;
    subTitle?: ContentBlockTextSubTitle;
    caption?: ContentBlockTextCaption;
    body: ContentBlockTextBody;
    buttonsCssClass?: string[];
    buttons: ContentBlockTextButton;
    showUnderlay?: boolean;
}

// Image Block
export interface ContentBlockImageStaticConfigBase {
    altText: string;
    plainImage?: boolean;
    contain?: boolean;
    autoResponsive?: boolean;
    fluidWidth?: boolean;
    fluidHeight?: boolean;
    fillHeight?: boolean;
    fillWidth?: boolean;
    position?: string;
    rounded?: RoundedValueCustom;
}

// Video Block
export interface ContentBlockVideoStaticConfigBase extends ContentBlockImageStaticConfigBase {
    videoUrlDesktop: string;
    videoUrlMobile: string;
}

export interface ContentBlockImageStatic {
    base: Partial<ContentBlockImageStaticConfigBase>;
    breakpoint?: PartialRecord<BreakpointType, Partial<ContentBlockImageStaticConfigBase>>;
    theme?: ThemeItem<ContentImage>;
    component?: {
        breakpoint?: PartialRecord<BreakpointType, ContentBlockThemeStyleItems>;
    }
}

export interface ContentBlockVideoStatic {
    base: Partial<ContentBlockVideoStaticConfigBase>;
    breakpoint?: PartialRecord<BreakpointType, Partial<ContentBlockVideoStaticConfigBase>>;
    theme?: ThemeItem<ContentImage>;
    component?: {
        breakpoint?: PartialRecord<BreakpointType, ContentBlockThemeStyleItems>;
    }
}

// Inline Video Block
export interface ContentBlockInlineVideo extends ContentLink, ContentVideoSource {
    video: ContentInlineVideoProps;
}

// Blocks

export type ContentBlockType = 'text' | 'image-static' | 'video-static' | 'inline-video';

export type ContentBlockConfigType = ContentBlockText | ContentBlockImageStatic | ContentBlockVideoStatic | ContentBlockInlineVideo;

// Block Layout Type

export enum LayoutTypeForFeatures {
    HALF = 'half',
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
    STACKED = 'stacked'
}


export interface ContentBlockCommonProps {
    theme: ThemeType;
    breakpoint: string;
    breakpointName: BreakpointType;
    isHyperlinkBlock?: boolean;
    isMobile: boolean;
}

export interface ContentBlockComponentProps extends ContentBlockCommonProps {
    block: ContentBlock;
}

export interface ContentSubBlockComponentProps extends ContentBlockCommonProps {
    id?: string;
    subBlock: BlockType;
}

export interface ContentBlocksComponentProps<T> extends ContentBlockCommonProps {
    config: T;
}
